import { BehaviorSubject } from "rxjs";
import { PersonaType } from "../models";

type SearchData = { query: string, types?: PersonaType[], page?: number };

const currentSearchSubject = new BehaviorSubject(
    localStorage.getItem('currentSearch') ?
        JSON.parse(localStorage.getItem('currentSearch') as string) as SearchData : undefined
);

export const searchService = {
    setSearch,
    currentSearch: currentSearchSubject.asObservable(),
    get currentSearchValue() { return currentSearchSubject.value },
};

function setSearch(data: SearchData) {
    localStorage.setItem('currentSearch', JSON.stringify(data));
    currentSearchSubject.next(data);
}
